<template>
    <div class="flex h-full items-center mb-auto mt-auto">
        <vs-checkbox v-model="selected" @change="select" class="inline-block" />
    </div>

</template>

<script>
export default {
	data() {
		return {
			selected: false,
		}
	},
	mounted() {
		this.checkAllSelected();
	},
	methods: {
		select() {
			if (this.selected) {
				this.$parent.selectedOrderIds = this.$parent.getOrders().map(order => {
					return order.order.id;
				});
			} else {
				this.$parent.selectedOrderIds = [];
			}
		},
		checkAllSelected() {
			const selectedOrdersCount = this.$parent.selectedOrderIds.length;
			const ordersCount = this.$parent.getOrders().length;

			this.selected = selectedOrdersCount === ordersCount;
		},
	}
}
</script>
